exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1sq95_EWKNjzV8fV-eooq9{display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.aXtaPMiPraMjpysbMusMq{overflow-x:hidden;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;position:relative}._2WJ2LUoG21KSQVBxUiHdTY,.aXtaPMiPraMjpysbMusMq{overflow-y:auto;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}._2WJ2LUoG21KSQVBxUiHdTY{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2WJ2LUoG21KSQVBxUiHdTY,._5h9rvgmd6PLe17Up2hO62{display:-webkit-box;display:-ms-flexbox;display:flex}._5h9rvgmd6PLe17Up2hO62{width:100%;overflow-y:auto}._34HdE2HiY45Lg6NvmtQ82V{position:absolute;width:100%}html[dir] ._34HdE2HiY45Lg6NvmtQ82V{background-color:\"[theme:neutralLight, default:#eaeaea]\"}._2m3-fQzp-N-lzClU-plV-e{height:60px}html[dir] ._2m3-fQzp-N-lzClU-plV-e{background:\"[theme:white, default:#ffffff]\"}", ""]);

// exports
exports.locals = {
	"container": "_1sq95_EWKNjzV8fV-eooq9",
	"outerScrollContainer": "aXtaPMiPraMjpysbMusMq",
	"wrapperDiv": "_2WJ2LUoG21KSQVBxUiHdTY",
	"draggableDiv": "_5h9rvgmd6PLe17Up2hO62",
	"rowWrapper": "_34HdE2HiY45Lg6NvmtQ82V",
	"spinnerPlaceHolder": "_2m3-fQzp-N-lzClU-plV-e"
};